module.exports = __webpack_public_path__ + "static/board-03-b7e5891add7b952f491da9bc6e9a3e56.jpg";